import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/history/date/HistoryDateContent/.eu';
import Kr from '@di-shared/features/history/date/HistoryDateContent/.kr';
import Na from '@di-shared/features/history/date/HistoryDateContent/.na';

export interface HistoryDateContentProps {
  vin: string;
  selectedDate: Date;
  isMonthChange: boolean;
}

export default function HistoryDateContent({vin, selectedDate, isMonthChange}: HistoryDateContentProps) {
  return (
    <>
      <Environment.Eu>
        <Eu
          vin={vin}
          selectedDate={selectedDate}
          isMonthChange={isMonthChange}
        />
      </Environment.Eu>
      <Environment.Kr>
        <Kr
          vin={vin}
          selectedDate={selectedDate}
          isMonthChange={isMonthChange}
        />
      </Environment.Kr>
      <Environment.Na>
        <Na
          vin={vin}
          selectedDate={selectedDate}
          isMonthChange={isMonthChange}
        />
      </Environment.Na>
    </>
  );
}
